import { Route } from 'react-router';
import { toRouteElement } from '@/router/toRouteElement';
import SchoolAppRoot from '@/routes/SchoolApp/appRoot';
import { schoolRoutes } from '@/routes/SchoolApp/router/routes';

const schoolRouter = (
  <Route element={<SchoolAppRoot />}>
    {/* Common */}
    {toRouteElement(schoolRoutes.SchoolHome)}
    {toRouteElement(schoolRoutes.SchoolClassroomList)}

    {/* Switchable */}
    {toRouteElement(schoolRoutes.SchoolClassroomDetail)}
    {toRouteElement(schoolRoutes.SchoolClassroomOverview)}
    {toRouteElement(schoolRoutes.SchoolClassroomInsights)}
    {toRouteElement(schoolRoutes.SchoolStudentList)}
    {toRouteElement(schoolRoutes.SchoolStudentDetail)}
    {toRouteElement(schoolRoutes.SchoolLessonList)}
    {toRouteElement(schoolRoutes.SchoolLessonDetail)}
    {toRouteElement(schoolRoutes.SchoolLiveSessionList)}
    {toRouteElement(schoolRoutes.SchoolLiveSessionHost)}

    {/* SchoolGroup pages */}
    {toRouteElement(schoolRoutes.SchoolGroupDashboard)}
    {toRouteElement(schoolRoutes.SchoolGroupSchoolList)}
    {toRouteElement(schoolRoutes.SchoolGroupSchoolDetail)}
    {toRouteElement(schoolRoutes.SchoolGroupClassroomList)}
    {toRouteElement(schoolRoutes.SchoolGroupUserList)}
  </Route>
);

export default schoolRouter;
